export const FLOATING_UI_DOM_ID = 'floating-ui-portal';
export const TOAST_DOM_ID = 'toast-portal';
